import {IRoutableModule} from '../../router/routing.infra';
import {ParticipantView} from './participant.view';
import {participantRouteLoader} from './participant.loader';

export default {
    loader: participantRouteLoader,
    Component: ParticipantView,
    storeAs: 'participantStore'
} as IRoutableModule;
